import { LocationUtilities } from './utils';
const callRates = function () {
  // variables
  var numberRates = {};
  var callRates = {};
  var ffoneNumCountryName = '';
  var ffoneNumCountryCode = '';
  var standardNumCountryCode = '';
  var outgoingNumCountryCode = '';
  // toll-free country list
  var settings = {
    'tollFree': {
      'US': 'us_tollfree',
      'GB': 'uk_tollfree',
      'CA': 'ca_tollfree',
      'AU': 'au_tollfree'
    }
  };
  var dateObject = new Date();
  var timeStamp = dateObject.getDay() + '' + dateObject.getMonth() + '' + dateObject.getYear();
  var product = jQuery('body').data('product-name');
  var numberRatesEndpoint = `/static-assets/js/${product}-number-rates.json?t=${timeStamp}`;
  var callChargesEndpoint = `/static-assets/js/${product}-call-charges.json?t=${timeStamp}`;
  // getting json files
  jQuery.getJSON(numberRatesEndpoint, function (json) {
    numberRates = json;
    constructMenu(numberRates, 'ffone_num_ul');
  }).done(function () {
    jQuery.getJSON(callChargesEndpoint, function (json) {
      callRates = json;
      constructMenu(callRates, 'standard_num_ul,outgoing_num_ul');
    }).done(function () {
      jQuery('.fworks-custom-dropdown .country-dropdown-content ul').each(function () {
        var selectList = jQuery(this).children('li');
        // sorting all country based dropdown list items
        selectList.sort(sort);
        jQuery(this).html(selectList);
      });
      function sort (a, b) {
        a = a.children[1].textContent.toLowerCase();
        b = b.children[1].textContent.toLowerCase();
        if (a > b) {
          return 1;
        } else if (a < b) {
          return -1;
        }
        return 0;
      }
      // default dropdown change event to update call-rates
      jQuery('#ffone_num_input, #standard_num_input, #outgoing_num_input').change();
      // form-utilities js adding active class for on-change input tags removing class
      jQuery('.select-dropdown').removeClass('active');
    });
  });
  // geoLocation init function
  function setSelected (obj) {
    var currentLocation;
    LocationUtilities.onLocationReady(function (geoLocation) {
      currentLocation = geoLocation.country.iso_code;
    });
    return (currentLocation in obj) ? currentLocation : 'US';
  }
  // menu generating function
  function constructMenu (obj, menuids) {
    // ffone number geo location checking
    var ffoneNumberGeoLocation = setSelected(obj);
    var menuId = menuids.split(',');
    for (var i = 0; i < menuId.length; i++) {
      var selectMenu = document.getElementById(menuId[i].replace(/\s/, ''));
      var list = '';
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          // skip country if it is Beta
          var isBeta = obj[key]['beta'];
          if (isBeta) {
            continue;
          }
          var countryName = obj[key]['name'] || obj[key]['country'];
          if (typeof countryName === 'undefined') {
            continue;
          }
          var selected = (ffoneNumberGeoLocation === key) ? 'selected = selected' : '';
          list += '<li class="option" data-country-code= "' + key + '"' + selected + '><i class="flag flag-' + key + '"></i><span>' + countryName + '</span></li>';
        }
      }
      list += '<li class="option error"><i></i><span>No matches found!</span></li>';
      selectMenu.innerHTML = list;
      // set default selected country name and flag to dropdown input
      var childrens = selectMenu.children;
      for (let i = 0; i < childrens.length; i++) {
        if (childrens[i].hasAttribute('selected')) {
          var setSelectedCountry = jQuery(selectMenu).parent().parent().find('.dropdown-select-input');
          var isoCode = childrens[i].getAttribute('data-country-code');
          setSelectedCountry.attr('data-iso-code', isoCode);
          setSelectedCountry.before('<i class="flag flag-' + isoCode + '"></i>');
          setSelectedCountry.attr('value', childrens[i].children[1].textContent);
        }
      }
    }
  }
  // number-rates starts here
  jQuery('#ffone_num_input').change(function () {
    ffoneNumCountryCode = jQuery(this).attr('data-iso-code');
    ffoneNumCountryName = jQuery(this).val();
    // setting default value
    // set ffoneNumCountry to standard and outgoing calls
    // updating ffoneNumCountry to standard and outgoing calls
    standardNumCountryCode = ffoneNumCountryCode;
    outgoingNumCountryCode = ffoneNumCountryCode;
    var callrates = ['standard', 'outgoing'];
    for (var i = 0; i < callrates.length; i++) {
      jQuery('#' + callrates[i] + '_num_input').attr('value', ffoneNumCountryName);
      jQuery('#' + callrates[i] + '_num_input').attr('data-iso-code', standardNumCountryCode);
      jQuery('#' + callrates[i] + '_num_input').parent().find('.flag').removeClass().addClass('flag flag-' + standardNumCountryCode + '');
      jQuery('#type_of_' + callrates[i] + '_num .dropdown-select-input').change();
    }

    const rateTypes = numberRates[ffoneNumCountryCode].number_rates;
    jQuery('#type_of_ffone_num .dropdown-content ul')
      .html(rateTypes.map(r =>
        `<li class="option" data-value=${r.value}>${r.label}</li>`
      ).join(''))
      .find('li:eq(0)').attr('selected', 'selected')
    ;
    jQuery('#type_of_ffone_num .dropdown-select-input').attr('value', rateTypes[0].label).change();
  });

  // number-rate price updates based on its type local or toll-free
  jQuery('#type_of_ffone_num .dropdown-select-input').change(function () {
    const value = jQuery('#type_of_ffone_num .dropdown-content li[selected]').data('value');
    jQuery('.ffone-price').text(value);
    jQuery('#standard_num_input').change();
  });

  // call-rates for standard aka incoming
  jQuery('#standard_num_input').change(function () {
    standardNumCountryCode = jQuery(this).attr('data-iso-code');
    jQuery('#type_of_standard_num .dropdown-select-input').change();
  });
  jQuery('#type_of_standard_num .dropdown-select-input').change(function () {
    var typeOfStandardNum = jQuery('#type_of_standard_num .dropdown-select-input').val().toLowerCase();
    // hide and show cost of number from and detailed price toggle link labels
    var costFromDetailedPrice = jQuery('.detailed-pricing.-standard, .cost-of-number-from.-standard');
    // update icons
    var icons = jQuery('#type_of_standard_num .select-dropdown');
    // updating incoming voice call rates based on the standard type browser or phone
    if (typeOfStandardNum === 'phone') {
      costFromDetailedPrice.addClass('active');
      icons.find('.icon-browser').removeClass('icon-browser').addClass('icon-call-phone');
    } else {
      icons.find('.icon-call-phone').removeClass('icon-call-phone').addClass('icon-browser');
      jQuery('#standard_detailed_pricing').removeClass('active');
      costFromDetailedPrice.removeClass('active');
    }
    standardCallRates(standardNumCountryCode);
  });
  // updates standard call rates for browser, phone and voicecall
  function standardCallRates (standardNumCountryCode) {
    var typeOfStandardNum = jQuery('#type_of_standard_num .dropdown-select-input').val().toLowerCase();
    var ffoneNumRateType = jQuery('#type_of_ffone_num .dropdown-select-input').val().toLowerCase();
    var number = callRates[standardNumCountryCode];
    var numberRateCountryCode = jQuery('#ffone_num_input').attr('data-iso-code');
    var price = settings['tollFree'][numberRateCountryCode] ? settings['tollFree'][numberRateCountryCode] : null;
    jQuery('#standard_detailed_pricing .detailed-pricing-body div').remove();
    if (ffoneNumRateType === 'toll-free') {
      if (typeOfStandardNum === 'phone') {
        getMinRateWithPopupData(number['numbers'], 'standard');
      } else {
        jQuery('.standard-num-price').text(callRates['INCOMING'][price]);
      }
      jQuery('.voice-mail-price').text(callRates['VOICEMAIL'][price]);
    } else {
      if (typeOfStandardNum === 'phone') {
        getMinRateWithPopupData(number['numbers'], 'standard');
      } else {
        jQuery('.standard-num-price').text(callRates['INCOMING']['standard']);
      }
      jQuery('.voice-mail-price').text(callRates['VOICEMAIL']['standard']);
    }
  }
  // updating min rate with popupData for standard local, toll-free and outging call-rates
  function getMinRateWithPopupData (popupData, requestFrom) {
    var minimumRate = [];
    // to update popup pricing details we use this classnames
    var popupIds = requestFrom === 'outgoing' ? 'outgoing' : 'standard';
    var ratesStartingRow = jQuery('#' + popupIds + '_detailed_pricing .detailed-pricing-body');
    var data = [];
    for (let key in popupData) {
      data.push({
        'prefix': key,
        'price': popupData[key][popupIds]
      });
    }
    // sorting number call rates list by value ascending order
    data.sort(function (a, b) {
      return parseFloat(a.price) - parseFloat(b.price);
    });
    // generating all number ratess with prices
    for (var i = 0; i < data.length; i++) {
      ratesStartingRow.append('<div><div class="rates-starting-with"><p>' + data[i]['prefix'].split(',').join(', ') + '</p></div><div class="rates-starting-rates"><h6>$' + data[i]['price'] + '</h6><p>per minute</p></div></div>');
      minimumRate.push(data[i]['price']);
    }
    jQuery('.' + popupIds + '-num-price').text(Math.min.apply(null, minimumRate));
  }
  // call-rates for outgoing functionality
  jQuery('#outgoing_num_input').change(function () {
    outgoingNumCountryCode = jQuery(this).attr('data-iso-code');
    jQuery('#type_of_outgoing_num .dropdown-select-input').change();
  });
  jQuery('#type_of_outgoing_num .dropdown-select-input').change(function () {
    outgoingCallRates(outgoingNumCountryCode);
  });
  function outgoingCallRates (outgoingNumCountryCode) {
    var number = callRates[outgoingNumCountryCode];
    jQuery('#outgoing_detailed_pricing .detailed-pricing-body div').remove();
    getMinRateWithPopupData(number['numbers'], 'outgoing');
  }
  // toggleClass for standard and outgoing call-rates details-pricing-popup.
  jQuery('.detailed-pricing').on('click', function () {
    jQuery('.fworks-custom-dropdown, .select-dropdown').removeClass('active');
    var selectDetailedPricingPopup = jQuery(this).parents('.call-rates-box').find('.detailed-pricing-popup');
    if (selectDetailedPricingPopup.hasClass('active')) {
      selectDetailedPricingPopup.removeClass('active');
    } else {
      selectDetailedPricingPopup.addClass('active');
      jQuery('html, body').animate({ scrollTop: selectDetailedPricingPopup.offset().top - 200 }, 500);
    }
  });
  /*
  * Close the dropdown menu if the user clicks outside of selected elements list.
  */
  jQuery(document).on('click', function (event) {
    var detailedPricingPopup = '.dropdown-select-input, .dropdown-content .option, .dropdown-content .option *, .search-country-input, .detailed-pricing, .detailed-pricing-popup, .detailed-pricing-popup *';
    if (!event.target.matches(detailedPricingPopup)) {
      // if detailed-pricing-popup remove class if user click out of scope
      if (jQuery('.detailed-pricing-popup.active')) {
        jQuery('.detailed-pricing-popup').removeClass('active');
      }
    }
  });
};

export { callRates };
